import { Box, Grid, Typography } from '@mui/material';
import { FC } from 'react';
import { translateLanguage } from 'components';
import { AccessDenied as AccessDeniedModel } from 'models';
import noAccess from 'assets/noAccess.png';
import properties from 'styles/properties.scss';
import styles from './index.module.scss';
import tokenService from 'utilities/token';

const AccessDenied: FC = () => {
  const isBfxLite: boolean = tokenService.isBfxLite()
  const heightDifference =
    parseInt(properties.headerHeight, 10) +
    parseInt(properties.footerHeight, 10) +
    parseInt(properties.mainContentPadding, 10) * 2;
  const accessDeniedMsg = isBfxLite ? {
    imgCaption: translateLanguage(
      `AccessDenied.${[AccessDeniedModel.ACCESSRESTRICTED]}`,
    ),
    desc1: translateLanguage(
      `AccessDenied.${[AccessDeniedModel.UPGRADEMSG]}`,
    ),
    desc2: translateLanguage(
      `AccessDenied.${[AccessDeniedModel.UPGRADEREACHOUT]}`
    )
  } : {
    imgCaption: translateLanguage(
      `AccessDenied.${[AccessDeniedModel.ACCESSDENIED]}`,
    ),
    desc1: translateLanguage(
      `AccessDenied.${[AccessDeniedModel.PERMISSIONMSG]}`,
    ),
    desc2: translateLanguage(
      `AccessDenied.${[AccessDeniedModel.REACHOUT]}`
    )
  }

  return (
    <Grid container>
      <Box
        sx={{
          minHeight: `calc(100vh - ${heightDifference}px)`,
        }}
      >
        <Box className={styles.noAccess}>
          <Box component="img" src={noAccess} alt="lock" />
          <Typography
            className={styles.accessDenied}
            component="div"
            data-testid="accessDenied"
          >
            {accessDeniedMsg.imgCaption}
          </Typography>
          <Typography
            className={styles.permissionMsg}
            component="div"
            data-testid="permissionTxt"
          >
            {accessDeniedMsg.desc1}
          </Typography>
          <Typography
            className={styles.permissionMsg}
            component="div"
            data-testid="reachoutMsg"
          >
            {accessDeniedMsg.desc2}
          </Typography>
        </Box>
      </Box>
    </Grid>
  );
};

export default AccessDenied;
